<template>
  <div style="text-align:center;margin-top:100px;">
    <img src="../assets/img/schmucklicloud_label_black.png" alt="schmuckliCloud" style="width:50%;">
    <h1>Coming in Late 2019</h1>
  </div>
</template>
<script>
export default{
  name: "Home",

}
</script>
